export default __webpack_public_path__ + "static/media/flag-palestine.b291e099.svg";